// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2020":"dfb21fca","6969":"dfb21fca"}[chunkId] + ".chunk.css";
};